
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Reiseart from '@/types/Reiseart';
    import { confirmSwal } from '@/helper/swals';
    import { SweetAlertResult } from 'sweetalert2';
    import { VForm } from '@/types/Components';
    import { DeleteReiseartPayload, ReiseartenFilter, UpdateReiseartPayload } from '@/store/reisearten';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('reisearten', ['loaders']),
        },
        methods: {
            ...mapActions('reisearten', ['loadReisearten', 'editReiseart', 'updateReiseart', 'deleteReiseart']),
            ...mapMutations('reisearten', ['setDialogsDetail']),
        },
    })
    export default class ReiseartenDetail extends Vue {
        @Prop() visible!: boolean;
        @Prop() reiseart!: Reiseart;
        @Prop() filter!: ReiseartenFilter;

        public $refs!: {
            form: VForm;
        };

        public updateReiseart!: (payload: UpdateReiseartPayload) => void;
        public deleteReiseart!: (payload: DeleteReiseartPayload) => void;

        public get isEdit(): boolean {
            return this.reiseart.reiseart_id !== null;
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
            }
        }

        public onClickSave(): void {
            if (this.$refs.form.validate()) {
                this.updateReiseart({ reiseart: this.reiseart, filter: this.filter });
            }
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Reiseart endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteReiseart({ reiseart: this.reiseart, filter: this.filter });
                    }
                });
        }
    }
